import React from "react";
import Sidebar from "../components/Sidebar";

function Troubleshooting() {
  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <h2>Troubleshooting</h2>
      </div>
    </div>
  );
}

export default Troubleshooting;